import ArticleLayout from '@/components/base/ArticleLayout';
import { articleSicurezza } from '@/mocks/articles';

export default function ArticleSicurezza() {
  return <ArticleLayout article={articleSicurezza} currentSlug="/guida-sicurezza-itaobuy" />;
}